import Form from "../form/Form";
import { edit } from '../../slices/settingsSlice';
import { appUrl } from "../../utils/fetch";

function ProfileInformation(props) {
    return (
        <Form 
            inputs={
                {
                    profileName: {
                        label: "Name and Surname",
                        field: "text",
                        width: 6,
                        sx: {
                            marginTop: 20,
                        },
                        merged: {
                            profileNickname: {
                                label: "Nickname (username)",
                                field: "text",
                            },
                            profilePhone: {
                                label: "Phone number",
                                field: "text"
                            },
                            profileStreet: {
                                label: "Street name and number",
                                field: "text"
                            },
                            profileCity: {
                                label: "City",
                                field: "text"
                            },
                            profileCountry: {
                                label: "Country",
                                field: "text"
                            },
                            profileZip: {
                                label: "ZIP code",
                                field: "text"
                            }
                        }
                    },
                    file_profilePicture: {
                        label: "Profile picture",
                        field: "upload",
                        currentImage: "current_file_profilePicture",
                        fileUrl: `${appUrl}/assets/file_profilePicture.png`,
                        width: 6,
                        buttonLabel: "Upload",
                        noInput: true,
                        sx: {
                            marginTop: "15px",
                        },
                        thumbnail: {
                            w: 180,
                            h: 180,
                        }
                    },
                }
            }
            columns={2}
            stateName="settings"
            dispatchFunc={edit}
            title={"Profile Information"}
            api={`${appUrl}/api/settings`}
            navbar
        />
    );
}

export default ProfileInformation;